import BrickTitle from "@/components/landing/BrickTitle";

const faqs = [
  {
    q: "How do you handle jobs with multiple different repair tasks?",
    a: "You can bundle everything on your honey-do or property checklist — from fixing a leaking gutter to welding a hinge and swapping electrical fixtures. We work systematically through the list under one transparent hourly or project rate.",
  },
  {
    q: "Are you certified to work on residential AC and refrigerants?",
    a: "Yes, I hold EPA Universal Certification, qualifying me to legally handle, recover, and recharge residential HVAC refrigerants safely and according to federal environmental standards.",
  },
  {
    q: "What if a replacement part for my appliance or fixture is discontinued?",
    a: "That is where 3D printing and custom fabrication come in. We can take exact measurements of the broken bracket or gear, 3D model it, and print a high-strength replacement part to restore your equipment.",
  },
  {
    q: "How soon can you start work after I request a quote?",
    a: "Quotes are reviewed and returned within two business hours. Depending on the current schedule and urgency (e.g. active roof leak or heat wave AC failure), service can often be scheduled within 24 to 48 hours.",
  },
];

export default function Faq() {
  return (
    <section className="py-20 max-w-4xl mx-auto px-4 sm:px-6" data-testid="faq-section">
      <div className="text-center mb-12">
        <span className="text-xs font-bold uppercase tracking-widest text-[#D4691E]">Got Questions?</span>
        <h2 className="text-3xl font-bold mt-2"><BrickTitle text="Frequently Asked Questions" /></h2>
      </div>

      <div className="space-y-4">
        {faqs.map((f, i) => (
          <div key={i} className="bg-white p-6 rounded-xl border border-[#E6DCD3]" data-testid={`faq-item-${i}`}>
            <h4 className="font-bold text-base text-[#1E252B]">{f.q}</h4>
            <p className="text-sm text-[#665E56] mt-2 leading-relaxed">{f.a}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
